import { useContext } from 'react';
import { PromptData } from '/business/shared/components/router/PromptUploadProvider';

export default function usePromptListener() {
  const { setPromptWhen, setPromptMessage, promptMessage, promptWhen } = useContext(PromptData);
  return {
    setPromptWhen,
    setPromptMessage,
    promptMessage,
    promptWhen,
  };
}
